import {IconButton, Tooltip} from "@mui/material";
import {
    BorderColorRounded,
    ContentCopyRounded,
    DescriptionRounded,
    LocalGasStationRounded,
    RequestQuoteRounded,
    SellRounded
} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import * as React from "react";
import {ReactNode, useState} from "react";
import {useHasScope} from "../../../config/globalConfig";

export enum ActionTypes {
    edit = "edit",
    details = "details",
    copy = "copy",
    invoice = "invoice",
    codes = "codes",
    kms='kms'
}

interface ActionButtonWithTooltipProps {
    type: ActionTypes;
    callback: Function;
    disabled?: boolean;
    auth?: string;
}

const ActionButtonWithTooltip = ({type, callback, disabled = false, auth}: ActionButtonWithTooltipProps) => {
    const {t} = useTranslation(['salesmarketing', 'translation']);
    const hasScope = useHasScope;

    const renderIcons = {
        [ActionTypes.edit]:<BorderColorRounded/>,
        [ActionTypes.details]:<DescriptionRounded/>,
        [ActionTypes.copy]:<ContentCopyRounded/>,
        [ActionTypes.invoice]:<RequestQuoteRounded/>,
        [ActionTypes.codes]:<SellRounded/>,
        [ActionTypes.kms]:<LocalGasStationRounded/>
    }
    return (
        (!auth || hasScope(auth)?
                <Tooltip title={!disabled ? t('tooltips.' + type) : ''} arrow>
                    <span>
                      <IconButton color="accent" onClick={() => {
                          callback()
                      }} disabled={disabled}>
                        {renderIcons[type]}
                      </IconButton>
                    </span>
                </Tooltip>
                :
                <></>
        )
    );
}
export default ActionButtonWithTooltip;